import type { Platform, Browser } from '../../core/utils/device';
import { envs, useAppContext } from '../../core';
import { PwaPage } from './enums';

/** Safari 26 (iOS 26) — первая версия с нативным промптом установки PWA */
const SAFARI_NATIVE_PWA_PROMPT_VERSION = 26;

/** iOS 16.4 — первая версия с поддержкой Web Push и полноценных PWA в WebKit */
const IOS_CHROME_MIN_VERSION = 16.4;

interface PageContext {
  platform: Platform;
  browser: Browser;
  browserVersion: number | null;
  osVersion: number | null;
  isInApp: boolean;
}

export function getPageKey(ctx: PageContext): PwaPage {
  const { platform, browser, browserVersion, osVersion, isInApp } = ctx;

  switch (true) {
    case platform === 'ios' && !!envs.APP_STORE_URL:
      return PwaPage.DisabledIos;
    case platform === 'ios' && isInApp:
      return PwaPage.InstallOther;
    case platform === 'ios' &&
      browser === 'safari' &&
      browserVersion !== null &&
      browserVersion >= SAFARI_NATIVE_PWA_PROMPT_VERSION:
      return PwaPage.InstallSafari;
    case platform === 'ios' &&
      browser === 'safari' &&
      browserVersion !== null &&
      browserVersion < SAFARI_NATIVE_PWA_PROMPT_VERSION:
      return PwaPage.InstallOldSafari;
    case platform === 'ios' && browser === 'chrome' && osVersion !== null && osVersion >= IOS_CHROME_MIN_VERSION:
      return PwaPage.InstallChrome;
    case platform === 'ios':
      return PwaPage.InstallOther;
    case platform === 'android' && !!envs.GOOGLE_PLAY_STORE_URL:
      return PwaPage.DisabledAndroid;
    default:
      return PwaPage.InstallDesktop;
  }
}

export function usePageKey(): PwaPage {
  const ctx = useAppContext();
  return getPageKey(ctx);
}
